export enum CustomerConversionType {
    ToCustomer = 0,
    ToLead = 1,
}
